module.exports = __webpack_public_path__ + "img/farming-woodlands-hero.987447a2.jpg";